import { BlockError } from '@domain/schemas/block-error';
import type { ResourceBlock, ResourceSection } from '@domain/schemas/contract.schema';

export const isBlockValid = ({ validationErrors = [] }: ResourceBlock): boolean =>
  validationErrors.filter((error) => error !== BlockError.UnresolvedComments).length === 0;
export const areSectionBlocksValid = ({ blocks = [] }: ResourceSection): boolean => blocks.every(isBlockValid);
